import { createAsyncThunk } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { fireUpdateFiltersEvent } from '@/microfrontends/filters/shared/eventsLog/events';
import { type TLocation } from '@/microfrontends/filters/shared/types/location';
import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';

import { type TThunkApi } from '../../types';

interface ISearchOffersPayload {
  jsonQuery: TJsonQuery;
  meta: ISearchMeta;
}

export const applyFilters = createAsyncThunk<ISearchOffersPayload, undefined, TThunkApi>(
  'searchOffers/update',
  async (_, thunkApi) => {
    const { getState } = thunkApi;

    const state = getState();
    const jsonQuery: TJsonQuery = state.jsonQuery.current;
    const meta: ISearchMeta = state.searchMeta.data;
    const currentLocation: TLocation = state.location.data;

    fireUpdateFiltersEvent({ jsonQuery, locations: tempNormalizeLocation(currentLocation), meta });

    return {
      jsonQuery,
      meta,
    };
  },
  {
    condition: (_, thunkApi) => {
      const state = thunkApi.getState();

      return state.listing.searchStatus !== 'loading';
    },
  },
);
